import { getMessageText } from "../../helper"
import * as Styled from "./styled"

export default (message) => (
  <Styled.Content key={message.timestamp}>
    {getMessageText(message.payload)}
  </Styled.Content>
)
